<template>
    <div v-show="visible">
        <el-dialog title="查看商品详情" :close-on-click-modal="false" v-loading="loading" :visible.sync="visible" :before-close="dialogClose" width="1000px">
            <div v-html="form.htmlContent"></div>
            <span slot="footer" class="dialog-footer">
                <el-button type="danger" @click="visible=false">关闭</el-button>
            </span>    
        </el-dialog>
    </div>
</template>
       
<script>
    import 'mavon-editor/dist/css/index.css';

    export default {
        data(){
            return{
                visible: false,
                loading:false,
                
                form:{
                    htmlContent:"",
                }
            }
        },
        components: {
        },
        created:function () {
        },
        methods:{
            init(data){
                this.visible=true;
                this.form.htmlContent=data.htmlContent;
            },
            dialogClose(done){
                done();
                this.$reload;
            }
        }
    }

</script>

<style scoped>
    .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 300px;
        display: inline-block;
    }
    .del-dialog-cnt{
        font-size: 16px;
        text-align: center
    }
    .table{
        width: 100%;
        font-size: 14px;
    }
    .red{
        color: #ff0000;
    }
    .mr10{
        margin-right: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/components/page/shop/order/CommodityDetail.vue